import { useEffect, useState } from "react";
import { apiFetch } from "@/api/client";

interface CanaleInfo {
  abilitato: boolean;
  link?: string;
}

/** Voce "WhatsApp" in sidebar: visibile solo se il backend dice abilitato (kill-switch). */
export function useWhatsappCanale(enabled: boolean): CanaleInfo {
  const [info, setInfo] = useState<CanaleInfo>({ abilitato: false });
  useEffect(() => {
    if (!enabled) return;
    let alive = true;
    apiFetch<CanaleInfo>("/whatsapp/canale")
      .then((d) => {
        if (alive) setInfo(d);
      })
      .catch(() => {
        /* canale invisibile su errore */
      });
    return () => {
      alive = false;
    };
  }, [enabled]);
  return info;
}
